import { usePreferences } from './usePreferences';

const useFilterSetsPreferences = (resource, initialValue) => usePreferences(`${resource}.list.filterSets`, initialValue);

export default useFilterSetsPreferences;